<template>
  <div class="card-cell">
    <div class="card-hd">
      <div class="card-hd-title">{{cardTitle}}</div>
      <template v-if="showStatus">
        <div v-if="status === 1" class="card-hd-status">{{isSail ? '已出行' : '已提交'}}</div>
        <div v-else-if="status === 2" class="card-hd-status is-cancel">已取消</div>
      </template>
    </div>
    <div class="card-bd">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShoppingCartCard',

  props: {
    cardTitle: {
      type: String,
      default: '超凡娱乐'
    },
    showStatus: {
      type: Boolean,
      default: false
    },
    status: {
      type: Number,
      default: -1
    },
    statusId: {
      type: Number,
      default: -1
    },
    subId: {
      type: Number,
      default: -1
    },
    isSail: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.card-cell{
  //padding-bottom: 45px;
  min-height: 200px;
  margin-bottom: 20px;
}
.card-hd {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-hd-title {
  font-size: 24px;
  line-height: 24px;
}
.card-hd-status {
  font-size: 24px;
  line-height: 24px;
  color: #fdc401;
  &.is-cancel {
    color: #909090;
  }
}
</style>
